/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/camelcase */
import React, { useContext, useEffect, useState } from 'react';
import GlobalContext from '../../contexts/GlobalContext';
import ThankYouPopup from './ThankYouPopup';
import Input from '../../components/Input/Input';
import {
  SubmitButtonClassVlaue,
  SubmitButtonDisabledClassVlaue
} from '../../types/regulatoryUpdateBundle';
import {
  getPayloadObject,
  getThanksText,
  action,
  actionData,
  subjectValue
} from '../../utils/regulatoryUpdatesBundle';
import { usePostJson } from '../../hooks/services/regulatoryUpdateBundlePostJson';
import { useSubmitFormWithReCaptcha } from '../../hooks/custom';

type RegulatoryUpdateBundleLoggedInPopupProps = {
  setClosePopup: Function;
  triggerActionGaEvent: Function;
};
type initialStateOfConditionObjectType = {
  actionNotSelectedError: boolean;
  successPopup: boolean;
  apiError: boolean;
  actionValue: string;
  successPopupText: string;
};

const RegulatoryUpdateBundleLoggedInPopup = (
  props: RegulatoryUpdateBundleLoggedInPopupProps
): JSX.Element => {
  const initialStateOfConditionObject: initialStateOfConditionObjectType = {
    actionNotSelectedError: false,
    successPopup: false,
    apiError: false,
    actionValue: '',
    successPopupText: ''
  };
  const { globalContext } = useContext(GlobalContext);
  const [conditionObject, setConditionObject] = useState(
    initialStateOfConditionObject
  );
  const [submitClassValue, setSubmitClassValue] = useState(
    SubmitButtonClassVlaue
  );
  const [actionValue, setActionnValue] = useState('');
  const submitFormWithReCaptcha = useSubmitFormWithReCaptcha();
  const onError = (): void => {
    setSubmitClassValue(SubmitButtonClassVlaue);
    let localConditionObject = conditionObject;

    localConditionObject = { ...localConditionObject, apiError: true };
    setConditionObject(localConditionObject);
  };
  const onSuccess = (): void => {
    globalContext.gtm.setVirtualPage('Privacy_Request_Request_Submitted');

    let localConditionObject = conditionObject;
    let thanksPopUpText = getThanksText(subjectValue.CUSTOMER);

    localConditionObject = {
      ...localConditionObject,
      successPopup: true,
      successPopupText: thanksPopUpText
    };
    setConditionObject(localConditionObject);
  };
  const [postJson] = usePostJson({ onSuccess: onSuccess, onError: onError });
  const closePopup = (): void => {
    props.setClosePopup(false);
    document.body.classList.remove('is-reveal-open');
  };
  const setActionStateValue = (value: React.SetStateAction<string>): void => {
    props.triggerActionGaEvent(value);

    let localConditionObject = conditionObject;

    localConditionObject = {
      ...localConditionObject,
      actionNotSelectedError: false,
      apiError: false
    };
    setConditionObject(localConditionObject);
    setActionnValue(value);
  };
  const setRadioButtonValue = (): void => {
    if (globalContext.gb.utils.getFromStore('retrieverequestat') === 'true') {
      setActionnValue(actionData.RETRIEVE);
      globalContext.gb.utils.removeFromStore('retrieverequestat');
    }

    if (globalContext.gb.utils.getFromStore('deletionrequestat') === 'true') {
      setActionnValue(actionData.DELETE);
      globalContext.gb.utils.removeFromStore('deletionrequestat');
    }
  };
  /**
   * This function will responsible for sending post data after validating action value selected or not
   */
  const onSubmit = (): void => {
    let localConditionObject = conditionObject;

    if (actionValue) {
      globalContext.gtm.pushVersionedEvent(
        '2.11',
        'CCPARequest',
        'ClickSubmitButton',
        'userLoggedInStatus= LoggedIn ,requestType=' +
          actionValue +
          ' ,userType=CUSTOMER',
        null,
        true
      );
      localConditionObject = {
        ...localConditionObject,
        actionNotSelectedError: false
      };
      setConditionObject(localConditionObject);
      setSubmitClassValue(SubmitButtonDisabledClassVlaue);
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const {firstName , lastName, email} = globalContext.customer
      const customer = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        phone: globalContext.gb.liquid.settings.contact_phone
      };

      submitFormWithReCaptcha(
        postJson,
        getPayloadObject({
          isLoggedIn: true,
          action: action.CCPA,
          customer: customer,
          requestType: actionValue,
          uuid: globalContext.customer.uuid
        })
      );
    } else {
      setConditionObject({
        ...localConditionObject,
        actionNotSelectedError: true
      });
    }
  };

  useEffect(() => {
    if (
      globalContext.gb.utils.getFromStore('openManageAccountScreen') === 'true'
    ) {
      globalContext.gb.utils.removeFromStore('openManageAccountScreen');
      setRadioButtonValue();
    }
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  useEffect(() => {}, [conditionObject]);

  return (
    <>
      {!conditionObject.successPopup && (
        <div>
          <button
            className="close-button modal-close"
            data-close=""
            aria-label="Close modal"
            type="button"
            onClick={closePopup}>
            <span aria-hidden="true" className="close-button__icon">
              ×
            </span>
          </button>
          <div className="regulatory-updates-modal__header">
            <h2 className="regulatory-updates__heading js-regulatory-updates-modal-heading">
              Privacy Requests
            </h2>
          </div>
          <div className="privacy-ccpa-loggedin">
            <div className="privacy-ccpa-options privacy-ccpa-options--loggedin">
              <p className="regulatory-updates__para regulatory-updates__para--privacy-options">
                I want to:
              </p>
              <ul className="radio-options privacy-ccpa__list">
                <li className="radio-options__li">
                  <Input
                    type="radio"
                    id="retrieve-data-option-li"
                    name="want_data_options"
                    value={actionData.RETRIEVE}
                    onChange={(e): void => setActionStateValue(e.target.value)}
                    checked={actionValue === actionData.RETRIEVE}
                  />
                  <label
                    htmlFor="retrieve-data-option-li"
                    className="radio-options__label">
                    Retrieve a copy of my data
                  </label>
                </li>
                <li className="radio-options__li">
                  <Input
                    id="delete-data-option-li"
                    type="radio"
                    name="want_data_options"
                    value={actionData.DELETE}
                    onChange={(e): void => setActionStateValue(e.target.value)}
                    checked={actionValue === actionData.DELETE}
                  />
                  <label
                    htmlFor="delete-data-option-li"
                    className="radio-options__label">
                    Request the deletion of my data
                  </label>
                </li>
                {conditionObject.actionNotSelectedError && (
                  <span className="real-time-error">Please Select Option</span>
                )}
              </ul>
            </div>
            <div className="privacy-login-details">
              <p className="regulatory-updates__para regulatory-updates__para--login-details">
                {globalContext.customer.firstName +
                  ' ' +
                  globalContext.customer.lastName}
              </p>
              <p className="regulatory-updates__para regulatory-updates__para--login-details">
                {globalContext.customer.email}
              </p>
              <p className="regulatory-updates__para regulatory-updates__para--login-details">
                {globalContext.gb.liquid.settings.contact_phone}
              </p>
              <p className="regulatory-updates__para privacy-login-text">
                We will use your email address on file to fulfill this request.
              </p>
            </div>
            {conditionObject.apiError && (
              <div className="real-time-error regulatory-updates-error">
                Something went wrong
              </div>
            )}
            <div>
              <button
                className={submitClassValue}
                type="submit"
                onClick={onSubmit}>
                submit
              </button>
            </div>
            <div className="captcha-note">
              This site is protected by reCAPTCHA and the Google{' '}
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                className="captcha-note__link">
                Privacy Policy
              </a>{' '}
              and{' '}
              <a
                href="https://policies.google.com/terms"
                target="_blank"
                className="captcha-note__link">
                Terms of Service
              </a>{' '}
              apply.
            </div>
          </div>
        </div>
      )}
      {conditionObject.successPopup && (
        <ThankYouPopup
          closePopUp={closePopup}
          message={conditionObject.successPopupText}
        />
      )}
    </>
  );
};

export default RegulatoryUpdateBundleLoggedInPopup;
